import React, { useState } from "react"

import useVideoUpload from "../hooks/useVideoUpload"

const VideoUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null)
  const { uploadState, uploadVideo, resetUploadState } = useVideoUpload()

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    setSelectedFile(file)
    resetUploadState()
  }

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a video file first")
      return
    }

    try {
      const result = await uploadVideo(selectedFile)
      console.info("Upload successful:", result) // eslint-disable-line no-console
      alert("Video uploaded and transcoding started!")
    } catch (error) {
      console.error("Upload failed:", error) // eslint-disable-line no-console
      alert("Upload failed: " + error.message)
    }
  }

  return (
    <div className="rounded-lg border-2 border-dashed border-gray-light bg-gray-ultralight p-8 text-center">
      <h3 className="mb-4 text-xl font-semibold text-gray-dark">Upload Video</h3>

      <div className="mb-4">
        <input
          type="file"
          accept="video/mp4,video/quicktime,video/x-msvideo,video/webm"
          onChange={handleFileChange}
          disabled={uploadState.isUploading || uploadState.isTranscoding}
          className="block w-full text-sm text-gray-dark file:mr-4 file:rounded-md file:border-0 file:bg-teal file:px-4 file:py-2 file:text-sm file:font-medium file:text-white hover:file:bg-teal-dark disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>

      {selectedFile && (
        <div className="mb-4 rounded-md border border-gray-light bg-white p-4 text-left">
          <p className="text-gray-dark">
            <strong>Selected:</strong> {selectedFile.name}
          </p>
          <p className="text-gray">
            <strong>Size:</strong> {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
          </p>
        </div>
      )}

      <button
        onClick={handleUpload}
        disabled={!selectedFile || uploadState.isUploading || uploadState.isTranscoding}
        className="mt-4 rounded-md bg-teal px-6 py-3 font-medium text-white transition-colors hover:bg-teal-dark disabled:cursor-not-allowed disabled:bg-gray">
        {uploadState.isUploading && "Uploading..."}
        {uploadState.isTranscoding && "Processing..."}
        {!uploadState.isUploading && !uploadState.isTranscoding && "Upload Video"}
      </button>

      {uploadState.isUploading && (
        <div className="relative my-4 h-5 w-full overflow-hidden rounded-full bg-gray-light">
          <div
            className="h-full bg-teal transition-all duration-300 ease-out"
            style={{ width: `${uploadState.uploadProgress}%` }}></div>
          <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-gray-dark">
            {uploadState.uploadProgress}%
          </span>
        </div>
      )}

      {uploadState.error && (
        <div className="mt-4 rounded-md border border-red bg-red-light p-4">
          <p className="text-red">Error: {uploadState.error}</p>
        </div>
      )}

      {uploadState.videoData && (
        <div className="mt-4 rounded-md border border-green bg-green-light p-4">
          <p className="text-white">Video uploaded successfully!</p>
          <p className="text-white">Job ID: {uploadState.videoData.job_id}</p>
        </div>
      )}
    </div>
  )
}

export default VideoUpload
